import { useCallback } from 'react';
import { ApolloError, gql, useLazyQuery } from '@apollo/client';
import { GenderModel, GendersModel, PageModelInput } from '@utmost.co/enterprise-models';

export const GET_GENDERS_QUERY = gql`
  query GET_GENDERS_QUERY($page: PageModelInput) {
    genders(page: $page) {
      limit
      offset
      totalCount
      items {
        uid
        name
        referenceId
        status
        assignable
        sourceName
      }
    }
  }
`;

interface Output {
  genders: GenderModel[];
  totalCount: number | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  fetch: (page: PageModelInput) => void;
}

export const useGenders: () => Output = () => {
  const [get, { data, loading, error }] = useLazyQuery<{ genders: GendersModel }, { page: PageModelInput }>(
    GET_GENDERS_QUERY
  );

  const fetch = useCallback(
    (page: PageModelInput) => {
      get({ variables: { page } });
    },
    [get]
  );

  return {
    genders: data?.genders.items ?? [],
    totalCount: data?.genders.totalCount,
    loading,
    error,
    fetch
  };
};
